export default function DomHandlers ()
{
  const domHandlers = {},
        assignedDomHandlers = {};


  const setHandler = (eventTarget, eventName, handler) =>
  {
    try
    {
      if (eventTarget && 'addEventListener' in eventTarget)
      {
        eventTarget.addEventListener(eventName, handler, false);
      }
    }
    catch(e){}
  };


  const unsetHandler = (eventTarget, eventName, handler) =>
  {
    try
    {
      if (eventTarget && removeEventListener in eventTarget)
      {
        eventTarget.removeEventListener(eventName, handler, false);
      }
    }
    catch(e){}
  };


  const runHandlers = (e) =>
  {
    if (!e || !e.target)
    {
      return true;
    }

    const eventTags = e.target.getAttribute('eventTags', 0);

    if (!eventTags)
    {
      return true;
    }

    let objectId = e.target.getAttribute('objectId', 0) || 'DefaultObjectId',
        eventTargets = eventTags ? eventTags.split(/\s+/) : null,
        etIndex,
        etLength,
        eventName = e.type;

    if (objectId in domHandlers && eventTargets)
    {
      for (etIndex = 0, etLength = eventTargets.length; etIndex < etLength; etIndex++)
      {
        if (eventTargets[etIndex] in domHandlers[objectId] && eventName && eventName in domHandlers[objectId][eventTargets[etIndex]])
        {
          for (let i = 0; i < domHandlers[objectId][eventTargets[etIndex]][eventName].handlers.length; i++)
          {
            domHandlers[objectId][eventTargets[etIndex]][eventName].handlers[i].handler(e, {'element': e.target, 'eventTags': eventTags, 'eventTarget': eventTargets[etIndex]});
          }
        }
      }
    }
  };


  const changeHandlers = (handlers, method) =>
  {
    for (let i = 0; i < handlers.length; i++)
    {
      if (Array.isArray(handlers[i]))
      {
        if(handlers[i][0] !== null)
        {
          if (Array.isArray(handlers[i][1]))
          {
            for (let n = 0; n < handlers[i][1].length; n++)
            {
              if (handlers[i][1][n][1] !== null)
              {
                method(handlers[i][0], handlers[i][1][n][0], handlers[i][1][n][1], (handlers[i][1][n][2] || undefined));
              }
            }
          }
          else
          {
            if (handlers[i][2] !== null)
            {
              method(handlers[i][0], handlers[i][1], handlers[i][2], (handlers[i][3] || undefined));
            }
          }
        }
      }
      else
      {
        if (handlers[i].target !== null && handlers[i].handler !== null)
        {
          method(handlers[i].target, handlers[i].name, handlers[i].handler, handlers[i].args);
        }
      }
    }
  };


  this.addHandler = (eventTarget, eventName, handler, args = {}) =>
  {
    if (!eventTarget) { return; } //TODO: DIME to fix site structure

    const objectId = args.objectId || 'DefaultObjectId',
          win = args.window || window,
          container = args.container || win.document.body;

    this.removeHandler(eventTarget, eventName, handler, args);

    if (typeof(eventTarget) === 'string')
    {
      if (!(objectId in domHandlers))
      {
        domHandlers[objectId] = {};
        domHandlers[objectId].counter = 0;
      }

      if (!(eventTarget in domHandlers[objectId]))
      {
        domHandlers[objectId][eventTarget] = {};
        domHandlers[objectId][eventTarget].counter = 0;
        domHandlers[objectId].counter++;
      }

      if (!(eventName in domHandlers[objectId][eventTarget]))
      {
        domHandlers[objectId][eventTarget][eventName] = {};
        domHandlers[objectId][eventTarget][eventName].handlers = [];
        domHandlers[objectId][eventTarget].counter++;
      }

      if (!(win.name in assignedDomHandlers && eventName in assignedDomHandlers[win.name]))
      {
        if (!(win.name in assignedDomHandlers))
        {
          assignedDomHandlers[win.name] = { };
        }

        assignedDomHandlers[eventName] = 0;
        setHandler(container, eventName, runHandlers);
      }

      domHandlers[objectId][eventTarget][eventName].handlers.push({'name': args.name || '', 'container': container, 'eventName': eventName, 'handler': handler});
      assignedDomHandlers[eventName]++;
    }
    else
    {
      setHandler(eventTarget, eventName, handler);
    }
  };


  this.removeHandler = (eventTarget, eventName, handler, args = {}) =>
  {
    const objectId = args.objectId || 'DefaultObjectId',
          win = args.window || window;

    let container = args.container || win.document.body,
        existingHandler,
        removingHandler;

    if (typeof(eventTarget) === 'string')
    {
      if (objectId in domHandlers && eventTarget in domHandlers[objectId] && eventName in domHandlers[objectId][eventTarget])
      {
        for (let i = domHandlers[objectId][eventTarget][eventName].handlers.length; i--;)
        {
          if (args.name)
          {
            existingHandler = domHandlers[objectId][eventTarget][eventName].handlers[i].name;
            removingHandler = args.name;
          }
          else
          {
            existingHandler = domHandlers[objectId][eventTarget][eventName].handlers[i].handler;
            removingHandler = handler;
          }

          if (existingHandler === removingHandler)
          {
            if (args.name)
            {
              container = domHandlers[objectId][eventTarget][eventName].handlers[i].container;
              eventName = domHandlers[objectId][eventTarget][eventName].handlers[i].eventName;
            }

            domHandlers[objectId][eventTarget][eventName].handlers[i].name = null;
            delete domHandlers[objectId][eventTarget][eventName].handlers[i].name;
            domHandlers[objectId][eventTarget][eventName].handlers[i].handler = null;
            delete domHandlers[objectId][eventTarget][eventName].handlers[i].handler;
            domHandlers[objectId][eventTarget][eventName].handlers.splice(i, 1);
            assignedDomHandlers[eventName]--;
            break;
          }
        }

        if (domHandlers[objectId][eventTarget][eventName].handlers.length === 0)
        {
          domHandlers[objectId][eventTarget][eventName] = null;
          delete domHandlers[objectId][eventTarget][eventName];
          domHandlers[objectId][eventTarget].counter--;

          if (domHandlers[objectId][eventTarget].counter === 0)
          {
            domHandlers[objectId][eventTarget] = null;
            delete domHandlers[objectId][eventTarget];
            domHandlers[objectId].counter--;

            if (domHandlers[objectId].counter === 0)
            {
              domHandlers[objectId] = null;
              delete domHandlers[objectId];
            }
          }
        }

        if (assignedDomHandlers[eventName] === 0)
        {
          unsetHandler(container, eventName, runHandlers);
          delete assignedDomHandlers[eventName];
        }
      }
    }
    else
    {
      unsetHandler(eventTarget, eventName, handler);
    }
  };


  this.addHandlers = (handlers) =>
  {
    changeHandlers(handlers, this.addHandler);
  };


  this.removeHandlers = (handlers) =>
  {
    changeHandlers(handlers, this.removeHandler);
  };


  this.stopEvent = (e, w = window) =>
  {
    e = e || w.event;

    if (e)
    {
      if ('stopPropagation' in e)
      {
        e.stopPropagation();
      }
      else
      {
        e.cancelBubble = true;
      }

      if ('preventDefault' in e)
      {
        e.preventDefault();
      }
      else
      {
        e.returnValue = false;
      }
    }

    return false;
  };


  this.stopEventBubbling = (e, w = window) =>
  {
    e = e || w.event;

    if (e)
    {
      if (e.stopPropagation)
      {
        e.stopPropagation();
      }
      else
      {
        e.cancelBubble = true;
      }
    }
  };


  this.addPageParsedHandler = (handler, args = {}) =>
  {
    let win = args.window || window;

    if (win.document.readyState === "loading")
    {
      win.document.addEventListener("DOMContentLoaded", handler);
    }
    else
    {
      handler();
    }
  };
}